import { List } from 'immutable'
import { SET_CURRENT_SITE } from 'modules/sites/action-types'
import { SIGN_OUT_SUCCESS } from 'modules/auth'
import { START_PARSING } from 'modules/sites/action-types'
import {
  LOAD_LINKS_SUCCESS,
  ADD_LINK_SUCCESS,
  CHANGE_LINK_SUCCESS,
  EMPTY_LINKS_LIST,
} from '../action-types'


export default function (state = new List(), { type, payload }) {
  switch (type) {
    case LOAD_LINKS_SUCCESS:
      return new List(payload.map((link, index) => link.set('index', index + 1)))

    case ADD_LINK_SUCCESS:
      return state.push(payload)

    case CHANGE_LINK_SUCCESS:
      return state.map(item => (
        item.key === payload.key ? payload.set('index', item.index) : item
      ))

    case START_PARSING:
    case SET_CURRENT_SITE:
    case SIGN_OUT_SUCCESS:
    case EMPTY_LINKS_LIST:
      return new List()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/links/reducers/links.js